export default "__VITE_ASSET__Dm4ryi28__"